// Главная = титульный экран: показывается ТОЛЬКО неавторизованному без начатой
// гостевой сессии (UX-вайрфрейм, экран 01). Залогиненный и гость с прогрессом
// попадают сразу на карту. Копия без формул/уроков — науч-поп принцип.

import { useEffect } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '@/auth/authStore';
import { loadSave } from '@/save/saveStore';

/** «Гость с активной сессией» = в локальном сейве уже есть уровни. */
function hasGuestSession(): boolean {
  return Object.keys(loadSave().levels).length > 0;
}

const STEPS = [
  { n: 1, title: 'Расставь инструменты', note: 'рампы, пружины, вентиляторы…' },
  { n: 2, title: 'Запусти — житель идёт сам', note: 'важен тайминг под багнаров' },
  { n: 3, title: 'Доведи до портала', note: 'уровень рефакторится начисто' },
] as const;

export function HomeScreen() {
  const auth = useAuth();
  const redirect = auth.status === 'authed'
    || (auth.status === 'guest' && hasGuestSession());

  // Лендинг — единственная страница игры, которой оставлен скролл страницы:
  // в остальной мете html/body зафиксированы (см. meta.css). Флаг снимается
  // на уходе, чтобы карта не унесла с собой скроллящийся вьюпорт.
  useEffect(() => {
    if (redirect) return;
    document.documentElement.dataset.page = 'landing';
    return () => { delete document.documentElement.dataset.page; };
  }, [redirect]);

  if (redirect) return <Navigate to="/map" replace />;

  return (
    <main className="meta-screen" data-testid="screen-home">
      <header className="meta-topbar">
        <span className="hint">web · v1</span>
        <Link to="/login" className="btn btn-sm" data-testid="login-link">Войти</Link>
      </header>

      {auth.status === 'loading' ? (
        <div className="title-hero"><p className="title-tag">Загрузка…</p></div>
      ) : (
        <>
          <div className="title-hero">
            <h1 className="title-logo">Дейв и Дельта</h1>
            <p className="title-tag">
              Конструктор-головоломка: расставь инструменты — и житель сам дойдёт до портала.
            </p>
            <Link to="/login" className="play-cta" aria-label="Играть" title="Играть" data-testid="play-cta">
              <img src="/assets/meta/button-play.png" alt="" />
            </Link>
          </div>
          <div className="title-steps">
            {STEPS.map((s) => (
              <div className="title-step" key={s.n}>
                <span className="step-num">{s.n}</span>
                <span><b>{s.title}</b><small>{s.note}</small></span>
              </div>
            ))}
          </div>
          <p className="title-facts">Мир прыжка уже открыт · играть можно без регистрации</p>
        </>
      )}
    </main>
  );
}
